import { ReactNode } from 'react';

import { ListX, LucideIcon } from '@/components/icons/barrel';
import { cn } from '@/utils/cn';

type Props = {
  title?: string;
  description?: ReactNode;
  children?: ReactNode;
  icon?: LucideIcon | (() => JSX.Element) | null;
  withoutIcon?: boolean;
  titleClassName?: string;
  descriptionClassName?: string;
  className?: string;
};

export default function Empty({
  children,
  icon: Icon = () => <ListX size={22} />,
  title = 'No records found.',
  description = 'No results have been found.',
  withoutIcon,
  titleClassName,
  descriptionClassName,
  className,
}: Props) {
  const renderIcon = () => {
    if (!Icon) return null;
    if (typeof Icon === 'function') {
      return <Icon />;
    }
    // Icon is a LucideIcon component
    const IconComponent = Icon as LucideIcon;
    return <IconComponent size={22} />;
  };

  return (
    <div
      className={cn(
        'mx-auto flex max-w-[82%] flex-col items-center justify-center gap-6',
        className,
      )}
    >
      <div className="flex flex-col items-center justify-center gap-1">
        {!withoutIcon && (
          <div className="mb-1 flex items-center justify-center">
            {renderIcon()}
          </div>
        )}

        <div
          className={cn(
            'text-center text-lg font-medium capitalize sm:text-xl',
            titleClassName,
          )}
        >
          {title}
        </div>

        <div
          className={cn(
            'text-center text-base text-vestgrey-100 sm:text-lg',
            descriptionClassName,
          )}
        >
          {description}
        </div>
      </div>

      {children}
    </div>
  );
}
